export const hasOneTrustActiveGroups = (): boolean =>
  Boolean(globalThis.OnetrustActiveGroups)

// OnetrustActiveGroups can be set before the SDK replaces window.OneTrust (ROK-6538).
export const isOneTrustReady = (): boolean =>
  hasOneTrustActiveGroups() &&
  typeof globalThis.OneTrust?.OnConsentChanged === 'function'

const triggerOneTrustOnLoad = (
  isAlreadyReady: boolean,
  setIsReady: (isReady: boolean) => void,
  isReady: () => boolean = hasOneTrustActiveGroups
): (() => void) => {
  /*
   * Returned to the caller's useEffect when there's no observer to tear down,
   * so every code path returns a cleanup function (satisfies consistent-return).
   */
  const noCleanup = () => undefined

  if (isAlreadyReady) return noCleanup

  // Already ready (e.g. on remount): a later body change isn't guaranteed, so set state directly.
  if (isReady()) {
    setIsReady(true)
    return noCleanup
  }

  const observer = new MutationObserver(() => {
    if (isReady()) {
      setIsReady(true)
      observer.disconnect()
    }
  })

  // subtree: OneTrust's own banner/preference-center updates also trigger a re-check.
  observer.observe(document.body, { childList: true, subtree: true })

  return () => observer.disconnect()
}

export default triggerOneTrustOnLoad
